<template>
    <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path fill-rule="evenodd" clip-rule="evenodd" d="M23.502 3C23.1042 3 22.7227 3.15804 22.4414 3.43934C22.16 3.72065 22.002 4.10218 22.002 4.5L22.002 39.879L12.564 30.438C12.2824 30.1563 11.9003 29.9981 11.502 29.9981C11.1037 29.9981 10.7217 30.1563 10.44 30.438C10.1584 30.7197 10.0001 31.1017 10.0001 31.5C10.0001 31.8983 10.1584 32.2803 10.44 32.562L22.44 44.562C22.5793 44.7017 22.7449 44.8125 22.9271 44.8881C23.1093 44.9638 23.3047 45.0027 23.502 45.0027C23.6993 45.0027 23.8947 44.9638 24.0769 44.8881C24.2591 44.8125 24.4247 44.7017 24.564 44.562L36.564 32.562C36.7035 32.4225 36.8141 32.257 36.8896 32.0748C36.9651 31.8925 37.0039 31.6972 37.0039 31.5C37.0039 31.1017 36.8457 30.7197 36.564 30.438C36.2824 30.1563 35.9003 29.9981 35.502 29.9981C35.1037 29.9981 34.7217 30.1563 34.44 30.438L25.002 39.879L25.002 4.5C25.002 4.10218 24.844 3.72065 24.5627 3.43934C24.2814 3.15804 23.8998 3 23.502 3Z" fill="currentColor"/>
    </svg>
</template>

<script>
export default {
    name: 'SVGArrowTooltipDown',
};
</script>

<style scoped lang="scss">

</style>
